import { render, staticRenderFns } from "./menu_section.vue?vue&type=template&id=4f9c47e6&vue3"
import script from "./menu_section.vue?vue&type=script&lang=js&vue3"
export * from "./menu_section.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports